/**
 * Terms of Service page.
 */

export function Terms() {
  return (
    <div className="pt-16">
      <div className="max-w-4xl mx-auto px-4 lg:px-8 py-24">
        <h1 className="text-4xl font-black text-white mb-8">Terms of Service</h1>
        <div className="prose prose-invert prose-gray max-w-none">
          <p className="text-gray-400 text-lg mb-8">
            Last updated: January 2026
          </p>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-4">1. Acceptance of Terms</h2>
            <p className="text-gray-400">
              By accessing or using bigflowdata services, you agree to be bound by these
              Terms of Service. If you do not agree, please do not use our services.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-4">2. Description of Service</h2>
            <p className="text-gray-400">
              bigflowdata provides Shopify analytics and product recommendation services.
              Our services analyze your store data to help you understand customer
              purchasing patterns and optimize product recommendations.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-4">3. Account Registration</h2>
            <p className="text-gray-400 mb-4">
              To use our services, you must:
            </p>
            <ul className="list-disc list-inside text-gray-400 space-y-2">
              <li>Provide accurate account information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Be at least 18 years old or have legal authority to accept these terms</li>
              <li>Have authorization to connect your Shopify store</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-4">4. Payment Terms</h2>
            <p className="text-gray-400 mb-4">
              Our services are provided on a subscription basis:
            </p>
            <ul className="list-disc list-inside text-gray-400 space-y-2">
              <li>15-day free trial for new accounts (card required)</li>
              <li>Monthly or annual billing cycles</li>
              <li>Automatic renewal unless cancelled</li>
              <li>Refunds at our discretion for annual plans</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-4">5. Cancellation</h2>
            <p className="text-gray-400">
              You may cancel your subscription at any time. Cancellation takes effect
              at the end of your current billing period. Trial cancellations are
              immediate and no charges will be made.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-4">6. Acceptable Use</h2>
            <p className="text-gray-400 mb-4">
              You agree not to:
            </p>
            <ul className="list-disc list-inside text-gray-400 space-y-2">
              <li>Violate any laws or regulations</li>
              <li>Interfere with or disrupt our services</li>
              <li>Attempt to gain unauthorized access</li>
              <li>Use our services for any harmful purpose</li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-4">7. Limitation of Liability</h2>
            <p className="text-gray-400">
              bigflowdata is provided "as is" without warranties. We are not liable for
              any indirect, incidental, or consequential damages arising from your use
              of our services.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-4">8. Changes to Terms</h2>
            <p className="text-gray-400">
              We may update these terms from time to time. We will notify you of
              significant changes via email or through our services.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-bold text-white mb-4">9. Contact</h2>
            <p className="text-gray-400">
              For questions about these terms, contact us at:{' '}
              <a href="mailto:info@bigflowdata.com" className="text-brand-500 hover:text-brand-400">
                info@bigflowdata.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}

